import React from "react";
import "./Order_Summary_gray_card.css";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";

function Order_Summary_gray_card({ order }) {
  const productSpecifications = [
    { label: "Total Amount", value: " 550.54" },
    { label: "Discount", value: " 40.54" },
    { label: "Amount Paid", value: "₹550.54" },
  ];

  const handleShare = (url) => {
    if (navigator.share) {
      navigator
        .share({
          title: "Check this out!",
          text: "Here’s something interesting I found:",
          url,
        })
        .catch((error) => console.error("Sharing failed", error));
    } else {
      // fallback: copy to clipboard or show message
      navigator.clipboard.writeText(url);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <>
      <section className="Order_Summary_gray_card">
        <div className="My_order_card">
          <div className="row">
            {/* Order Summary Details Section */}
            <div className="col-md-12 col-sm-12 ">
              <div className="card_inner_content">
                <div className="heading_status_holder">
                  <div className="heading_holder">
                    <h3>Order Summary</h3>
                  </div>
                </div>
              </div>

              <div className="card_inner_content card_inner_content_two">
                <div className="main_table_holder">
                  <div className="row justify-content-between">
                    <div className="col-md-6">
                      <div className="heading_table_holder">
                        <div className="info_table_holder">
                          <Table responsive>
                            <tbody>
                              <tr>
                                <td>Sub Total :</td>
                                <td className="fw-bold">
                                  ₹{" "}
                                  {(Number(order?.amount_paid) || 0).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td>Offer Discount :</td>
                                <td className="fw-bold">
                                  ₹{" "}
                                  {(Number(order?.offer_discount) || 0).toFixed(
                                    2
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>Coupon Discount :</td>
                                <td className="fw-bold">
                                  ₹{" "}
                                  {(
                                    Number(order?.coupon_discount) || 0
                                  ).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td>Total Tax :</td>
                                <td className="fw-bold">
                                  ₹ {(Number(order?.total_gst) || 0).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td>Total :</td>
                                <td className="fw-bold">
                                  ₹ {(Number(order?.total) || 0).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-sm-4 col-6 ">
                      <div className="img_share_holder">
                        <div className="product_img_holder">
                          <img
                            src={
                              process.env.REACT_APP_IMG_URL +
                              order?.Product?.Product_Images[0]?.image
                            }
                            className="product_img"
                            alt="product_img"
                          />
                        </div>
                        <Link
                          to={`${
                            process.env.REACT_APP_WEBSITE_URL
                          }/product-details-page/${encodeId(
                            order?.Product?.id
                          )}`}
                        >
                          <div
                            className="share_icon_holder"
                            style={{ cursor: "pointer" }} // Optional: makes it look clickable
                          >
                            <FontAwesomeIcon
                              className="share_icon"
                              icon={faShareNodes}
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_Summary_gray_card;
